<script>
const mapTitle = {
  'common.orgStructureFile': 'Ссылка на оргструктуру',
};

export default {
  props: {
    entityId: {
      type: String,
      required: true,
    },
    changes: {
      type: Array,
      required: true,
    },
  },
  render () {
    return (
      <div class="journal-diff">
        <div class="journal-diff__field">
          {mapTitle[this.entityId] || this.entityId}
        </div>
        {this.changes.map((change, i) => {
          const { lhs, rhs } = change;

          return (
            <div key={i}>
              {lhs && (
                <span class="journal-diff__del">
                  {lhs}
                </span>
              )}
              {rhs && (
                <span class="journal-diff__ins">
                  {rhs}
                </span>
              )}
            </div>
          );
        })}
      </div>
    );
  },
};
</script>
